interface IGameHandler {
  [k: string]: any[];
}

export class PoGameInternal {
  private _config: any = null;

  public get config() {
    return this._config;
  }

  /* initialization events */
  private handlers: IGameHandler = {
    onGameEndHandler: [],
    onGameErrorHandler: [],
    onGameReplayHandler: [],
    onGameExitHandler: [],
    onGamePauseHandler: [],
    onGameReadyHandler: [],
    onGameResumeHandler: [],
    onGameResultHandler: [],
    onGameStartHandler: [],
    onPreviousGameHandler: [],
    onNextGameHandler: [],
    onEnterTicketHandler: [],
    updateAutoPlayHandler: [],
    onLatestGameHandler: []
  };

  setConfig(config: any) {
    this._config = config;
  }

  getConfig() {
    return this._config;
  }

  /**
   * Add a function to a handler.
   *
   * @param handler
   *            handler The handler
   * @param method
   *            func The function to add to the handler.
   */
  registerHandler(handler: string, method: (args?: any) => void) {
    if (typeof method === 'function') {
      if (this.handlers.hasOwnProperty(handler)) {
        this.handlers[handler].push(method);
      }
    }
  }

  /**
   * Execute a handler.
   *
   * @param handlerName The handler to execute.
   * @param args The arguments to execute the handler with.
   */
  executeHandler(handlerName: string, args?: any) {
    if (this.handlers.hasOwnProperty(handlerName)) {
      for (let i = 0; i < this.handlers[handlerName].length; i++) {
        const func = this.handlers[handlerName][i];
        args = typeof args !== 'undefined' ? args : null;
        if (args === null) {
          func();
        } else {
          func(args);
        }
      }
    }
    return true;
  }

  /**
   * End the current game
   */
  end(data?: any) {
    this.setConfig(null);
    this.executeHandler('onGameEndHandler', data);
  }

  /**
   * Report a caught exception
   */
  error(error) {
    this.executeHandler('onGameErrorHandler', error);
  }

  /**
   * Replay another game.
   */
  replay() {
    this.executeHandler('onGameReplayHandler');
  }

  /**
   * Exit the game.
   */
  exit() {
    this.executeHandler('onGameExitHandler');
  }

  /**
   * Notify the game has been paused.
   */
  pause() {
    this.executeHandler('onGamePauseHandler');
  }

  /**
   * The game is ready to start.
   */
  ready() {
    this.executeHandler('onGameReadyHandler');
  }

  /**
   * The game points.
   * @param obj
   */
  result(obj) {
    this.executeHandler('onGameResultHandler', obj);
  }

  /**
   * Resume the current game.
   */
  resume() {
    this.executeHandler('onGameResumeHandler');
  }

  /**
   * Started a new game.
   */
  start() {
    this.executeHandler('onGameStartHandler');
  }

  /**
   * Enter ticket.
   * @param obj
   */
  enterTicket(obj) {
    this.executeHandler('onEnterTicketHandler', obj);
  }

  /**
   * Get previous game.
   */
  getPreviousGame() {
    this.executeHandler('onPreviousGameHandler');
  }

  /**
   * Get next game.
   */
  getNextGame() {
    this.executeHandler('onNextGameHandler');
  }

  /**
   * Update auto play value
   */
  updateAutoPlay(obj) {
    this.executeHandler('updateAutoPlayHandler', obj);
  }

  /**
   * Get latest game.
   */
  getLatest() {
    this.executeHandler('onLatestGameHandler');
  }
}
